/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { User } from "./User";
import * as t from "io-ts";

// required attributes
const SessionR = t.interface({});

// optional attributes
const SessionO = t.partial({
  idPayment: t.string,

  sessionToken: t.string,

  user: User
});

export const Session = t.intersection([SessionR, SessionO], "Session");

export type Session = t.TypeOf<typeof Session>;
